import React, { useMemo } from 'react'
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, Box } from '@mui/material'
import '../../styles/dropdown.css'

const normalizeOptions = (options) => {
  if (!options) return []
  return options.map((opt) => (
    typeof opt === 'string' ? { value: opt, label: opt } : { value: opt.value ?? opt.id ?? opt.key ?? opt.label, label: opt.label ?? String(opt.value) }
  ))
}

const AccessibleSelect = ({
  label,
  value,
  onChange,
  options,
  required,
  helperText,
  error,
  fullWidth = true,
  ariaLabel,
  name,
  id,
  disabled,
  size = 'small',
}) => {
  const items = normalizeOptions(options)
  const minWidth = useMemo(() => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (!ctx) return 180
    ctx.font = '14px Arial, Helvetica, sans-serif'
    const texts = [label || '', ...items.map(i => i.label || '')]
    const max = Math.max(...texts.map(t => Math.ceil(ctx.measureText(String(t)).width)))
    const padding = 56
    return Math.max(180, max + padding)
  }, [label, items])
  return (
    <FormControl fullWidth={fullWidth} error={Boolean(error)} disabled={disabled} className="dropdown-accessible" style={{ minWidth }} size={size}>
      <InputLabel required={Boolean(required)} id={`${id || name}-label`} shrink>{label}</InputLabel>
      <Select
        labelId={`${id || name}-label`}
        id={id}
        name={name}
        value={value ?? ''}
        label={label}
        onChange={onChange}
        aria-label={ariaLabel || label}
        size={size}
        displayEmpty
        renderValue={(val) => {
          if (!val) return <Box sx={{ color: 'text.secondary', fontStyle: 'italic' }}>Select...</Box>;
          return (
            <Box className="dropdown-value" title={items.find(i => i.value === val)?.label || ''}>
              {items.find(i => i.value === val)?.label || ''}
            </Box>
          );
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              fontSize: 14,
              lineHeight: '21px',
            }
          }
        }}
        sx={{
          fontSize: 14,
          lineHeight: '21px',
          '& .MuiSelect-select': size === 'small' ? {} : { paddingTop: '8px', paddingBottom: '8px' },
        }}
      >
        <MenuItem value="" disabled sx={{ fontSize: 14, lineHeight: '21px', py: 1, fontStyle: 'italic', color: 'text.secondary' }}>
            Select...
        </MenuItem>
        {items.map((opt) => (
          <MenuItem key={String(opt.value)} value={opt.value} sx={{ fontSize: 14, lineHeight: '21px', py: 1 }}>
            <Box className="dropdown-item" title={opt.label}>{opt.label}</Box>
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}

export default AccessibleSelect
